import React from 'react';
import { useTranslation } from '@yme/services/i18n';
import { SVGIcon } from '../svg-icon';
import { LanguageSelectorButtonStyled, LanguageSelectorMinifiedButtonStyled } from './styled';
export function LanguageSelectorButton(props) {
    const { onClick, isRightToLeft, iconComponent, hasIcon = false, label, isMinified, isLight, } = props;
    const { t } = useTranslation();
    const childComponent = !hasIcon ? (label) : (React.createElement(React.Fragment, null,
        React.createElement(SVGIcon, { type: iconComponent }),
        label));
    return isMinified ? (React.createElement(LanguageSelectorMinifiedButtonStyled, { onClick: onClick, "aria-label": t('common_languageSelectorDropdown_accessibility') },
        React.createElement(SVGIcon, { type: iconComponent }))) : (React.createElement(LanguageSelectorButtonStyled, { type: "button", onClick: onClick, isRightToLeft: isRightToLeft, isLight: isLight, "aria-label": t('common_languageSelectorDropdown_accessibility') }, childComponent));
}
LanguageSelectorButton.displayName = 'LanguageSelectorButton_Component';
